import VueLogger from 'vuejs-logger';
import Vue from 'vue';
import { loggerOptions } from '@/config';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
Vue.use(VueLogger as any, loggerOptions);
